export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12403.18c58677.jpg";